import { forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type FeaturedIconSize = "sm" | "md" | "lg" | "xl";
export type FeaturedIconColor = "brand" | "gray" | "success" | "warning" | "error";
export type FeaturedIconType = "modern" | "glass" | "dark" | "light";

export type FeaturedIconProps = HTMLAttributes<HTMLDivElement> & {
  size?: FeaturedIconSize
  type?: FeaturedIconType
  color?: FeaturedIconColor
};

export const FeaturedIcon = memo(forwardRef<HTMLDivElement, FeaturedIconProps>((
  {
    size = "md",
    type = "modern",
    color = "gray",
    children,
    className,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[size],
        styles[type],
        styles[color],
      )}
    >
      {children}
    </div>
  );
}));